<template>
  <section class="cost mt-0" v-if="localErrand">

    <h2>{{ $t('overview.chartTitle') }}</h2>

    <div v-if="showCharts">
      <template>
        <div class="cost__chart">
          <div id="chart" role="img"></div>
        </div>
        <table class="cost__table">
          <tr class="cost__summary-row">
            <td colspan="2">
              {{ $t('overview.totalCost') }}:
            </td>
            <td>
              {{ formatPrice(calcTotal) }}
            </td>
          </tr>
          <tr v-for="share in shareList" :key="share.id">
            <td><div class="cost__color" :data-color="share.id" role="img"></div></td>
            <th>{{ share.name }}</th>
            <td>{{ formatPrice(share.costString) }}</td>
          </tr>
        </table>
      </template>
    </div>
    <div v-else class="cost__empty">
      <p class="cost__empty">
        {{ $t('overview.noChart') }}
      </p>
    </div>

    <div v-if="isContentManager || isGlobalAdmin" class="admin-section">
      <div>
        {{ $t('overview.housingCorp') }}: <input type="number" v-model.number="localErrand.calcBrfPart">
      </div>
      <div>
        {{ $t('overview.customer') }}: <input type="number" v-model.number="localErrand.calcCustomerPart">
      </div>
      <div>
        {{ $t('overview.insuranceCompany') }}: <input type="number" v-model.number="localErrand.calcInsurancePart">
      </div>
      <button class="button--secondary" :class="{ 'is-loading' : isSubmitting }" @click="apply">{{ $t('overview.saveCalculations') }}</button>
    </div>

  </section>
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'
import rpcService from '@/core/services/rpc-service'
import { GoogleCharts } from 'google-charts'
import Vue from 'vue'
import { formatPrice } from '@/core/formatting'
import toasts from '@/core/toasts'

export default {
  data: () => ({ chartsLoaded: false, isSubmitting: false }),
  mounted() {
    Vue.nextTick(this.drawChart)
  },
  methods: {
    formatPrice,
    apply() {
      this.isSubmitting = true
      rpcService
        .submitCalculations(this.localErrand)
        .done(updatedErrand => {
          _.assign(this.localErrand, updatedErrand)
          toasts.success(this.$t('overview.costsUpdated'))
        })
        .fail(() => {
          toasts.error(this.$t('overview.costUpdateError'))
        })
        .always(() => {
          this.isSubmitting = false
        })
    },
    getChartBgColor() {
      return $(this.$el)
        .find('.cost__chart')
        .css('background-color')
    },
    showModal() {
      this.$modal.show('modalCost')
    },
    drawChart() {
      if (!this.showCharts) {
        return
      }
      GoogleCharts.load(this.renderChart)
    },
    renderChart() {
      const data = GoogleCharts.api.visualization.arrayToDataTable([
        ['Chart thing', 'Chart amount'],
        [
          this.$t('overview.insuranceCompany'),
          this.localErrand.calcInsurancePart
        ],
        [this.$t('overview.housingCorp'), this.localErrand.calcBrfPart],
        [this.$t('overview.yourCost'), this.localErrand.calcCustomerPart]
      ])
      var options = {
        backgroundColor: 'transparent', // this.getChartBgColor(),
        chartArea: {
          height: '80%'
        },
        pieHole: 0.5,
        pieStartAngle: 0,
        slices: [
          {
            color: this.uiColors['insurance']['background'],
            textStyle: { color: this.uiColors['insurance']['color'] }
          },
          {
            color: this.uiColors['brf']['background'],
            textStyle: { color: this.uiColors['brf']['color'] }
          },
          {
            color: this.uiColors['private']['background'],
            textStyle: { color: this.uiColors['private']['color'] },
            offset: 0.15
          }
        ],
        legend: {
          position: 'none'
        }
      }

      const donutChart = new GoogleCharts.api.visualization.PieChart(
        $(this.$el).find('#chart')[0]
      )
      donutChart.draw(data, options)
    }
  },
  computed: {
    shareList() {
      return [
        {
          name: this.$t('overview.insuranceCompany'),
          cost: this.localErrand.calcInsurancePart,
          costString: this.localErrand.calcInsurancePart,
          id: 'insurance'
        },
        {
          name: this.$t('overview.housingCorp'),
          cost: this.localErrand.calcBrfPart,
          costString: this.localErrand.calcBrfPart,
          id: 'brf'
        },
        {
          name: this.$t('overview.yourCost'),
          cost: this.localErrand.calcCustomerPart,
          costString: this.localErrand.calcCustomerPart,
          id: 'private'
        }
      ]
    },
    calcTotal() {
      return (
        this.localErrand &&
        this.localErrand.calcInsurancePart +
          this.localErrand.calcCustomerPart +
          this.localErrand.calcBrfPart
      )
    },
    showCharts() {
      return this.calcTotal > 0 || (this.isContentManager || this.isGlobalAdmin)
    },
    uiColors() {
      const $colorElements = $(this.$el)
        .find('[data-color]')
        .get()
      return _.reduce(
        $colorElements,
        (acc, element) => {
          acc[$(element).data('color')] = {
            background: $(element).css('background-color'),
            color: $(element).css('color')
          }
          return acc
        },
        {}
      )
    }
  },
  watch: {
    calcTotal(value) {
      if (value > 0) {
        this.drawChart()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-section {
  button {
    width: 49%;
  }
  div {
    margin: 10px 0;
  }
  input {
    margin: 0 0.25rem;
    width: 150px;
    border: 1px solid #eee;
    padding: 5px;
    border-radius: 5px;
    transition: border-color 0.5s ease-out;
  }
}

.cost {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

div.cost__empty {
  @include layout-box;
  flex-grow: 1;
}

p.cost__empty {
  padding: 3rem measure(s);
  text-align: center;
  @include font-size(s);
}

.cost__chart {
  background-color: color(subtle);
  height: 19.6875rem;
  position: relative;
  padding-top: measure(s);
  padding-bottom: measure(s);
  @include layout-box;
  padding-top: measure(s);
  padding-bottom: measure(s);

  [role="img"] {
    margin-top: -2.5%;
    height: 19.6875rem;
    width: 100%;
  }
}

.cost__table {
  width: 100%;
  margin-top: measure(xxs);
  @include font-size(s);
  border-spacing: 0 measure(xxs);

  th {
    font-weight: inherit;
    text-align: inherit;
    width: 100%; // Avoid line break
  }

  td:first-child {
    width: measure(l);
  }

  td:last-child {
    text-align: right;
    white-space: nowrap;
  }

  tr:last-child > * {
    border-bottom: solid 1px color(light);
    padding-bottom: measure(xs);
  }
}

.cost__summary-row {
  + tr > * {
    padding-top: measure(xxs);
  }

  td {
    @include font-size(s);
    font-weight: bold;
    padding-bottom: measure(xs);
    border-bottom: solid 1px color(light);

    &:first-child {
      width: 100%;
    }

    &:last-child {
      width: auto;
    }
  }
}

.cost__color {
  width: $dot-size;
  height: $dot-size;
  border-radius: 50%;
  margin-right: 0.5em;

  &[data-color="brf"] {
    background-color: color(primary);
    color: color(white);
  }

  &[data-color="insurance"] {
    background-color: color(secondary);
    color: color(white);
  }

  &[data-color="private"] {
    background-color: color(medium-light);
    color: color(jet);
  }
}

.cost__icon {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  position: absolute;
  top: measure(s);
  right: measure(s);

  &:focus {
    @include focus;
  }
}
</style>
